export default __webpack_public_path__ + "static/media/rotaract.30b19bb1.jpg";